import React, { createRef, useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Checkbox,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Tooltip,
  PaginationItem,
  Pagination,
} from "@mui/material";
import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";
import LoadingSpinner from "../../components/LoadingSpinner";
import EmptyRows from "../../components/reusableComponent/EmptyRows";
import { maskEmail, maskPhoneNumber } from "../reusableComponent/MaskedFields";
import { CIRCLEONE_TEAM, CIRCLEONE_USERNAME } from "../../constants";
import { useCampignsDynamicFieldsQuery } from "../../Services/campign/campignList";
interface IProps {
  listOfLeads: any;
  taskRes: any;
  CampaignWorkflow: any;
  setStoreKey: any;
  setValue: any;
  value: any;
  currentPage;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  useData: any;
  campign: any;
  setSelectedTickets;
  selectedTickets: any;
  selectedOptions: any;
  checkTenant: any;
  refetch: any;
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
}

const CampaignListView: React.FC<IProps> = ({
  listOfLeads,
  checkTenant,
  taskRes,
  CampaignWorkflow,
  setStoreKey,
  setValue,
  value,
  currentPage,
  setCurrentPage,
  campign,
  setSelectedTickets,
  selectedTickets,
  selectedOptions,
  refetch,
  pageSize,
  setPageSize,
}) => {
  const taskResActionMenuRef = useRef<any[]>([]);
  taskResActionMenuRef.current = taskRes.map(
    (item: any, i: number) => taskResActionMenuRef.current[i] ?? createRef(),
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectAll, setSelectAll] = useState(false);
  const [uiData, setUiData] = useState([]);
  const [keyState, setKeyState] = useState([]);
  const pageSizeOptions = [5, 10, 25, 50, 100];

  const checkUserRole = localStorage.getItem("user_role");
  const checkTeam = localStorage.getItem(CIRCLEONE_TEAM);
  const checkUsername = localStorage.getItem(CIRCLEONE_USERNAME);
  const { data: ticketDynamicFields } = useCampignsDynamicFieldsQuery({});
  const [dynamicFieldData, setDynamicFieldData] = useState<any>([]);

  const navigate = useNavigate();
  const rows =
    campign?.results?.map((campign: any) => ({
      id: campign?.id,
      first_name: campign?.first_name,
      // created: format(new Date(ticket?.created), "yyyy-MM-dd HH:mm"),
      last_name: campign?.last_name,
      account_name: campign?.account_name,
      email: campign?.email,
      phone_number: campign?.phone_number,
      category: campign?.category,
      dynamic_fields: campign?.dynamic_fields,
      assignee: campign?.assignee?.username,
      outstanding_amount: campign?.outstanding_amount,
      is_high_priority: campign?.is_high_priority,
      channel_name: campign?.channel_name,
    })) || [];
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const handleSelect = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number,
  ) => {
    const newSelectedTickets = event.target.checked
      ? [...selectedTickets, id]
      : selectedTickets.filter((ticketId) => ticketId !== id);

    setSelectedTickets(newSelectedTickets);

    // Uncheck "Select All" if any checkbox is unchecked
    if (!event.target.checked) {
      setSelectAll(false);
    }
  };
  const generatePaginationNumbers = () => {
    const numbers = [];
    const maxVisibleNumbers = 5;

    if (totalPages <= maxVisibleNumbers) {
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i);
      }
    } else {
      const middleIndex = Math.ceil(maxVisibleNumbers / 2);
      let startPage = currentPage - middleIndex + 1;
      let endPage = currentPage + middleIndex - 1;

      if (startPage < 1) {
        endPage = startPage + maxVisibleNumbers - 1;
        startPage = 1;
      } else if (endPage > totalPages) {
        startPage = endPage - maxVisibleNumbers + 1;
        endPage = totalPages;
      }

      for (let i = startPage; i <= endPage; i++) {
        numbers.push(i);
      }
    }

    return numbers;
  };
  const processData = async () => {
    const uiFormattedData = [];
    const keysForState = [];

    // const [selectedTab, setSelectedTab] = useState<number>(0);
    if (CampaignWorkflow && typeof CampaignWorkflow === "object") {
      await Object.entries(CampaignWorkflow)?.forEach(([key, value]) => {
        if (
          typeof value === "object" &&
          value !== null &&
          !Array.isArray(value)
        ) {
          // Handle objects like { Open: 8 }
          Object.entries(value).forEach(([nestedKey, nestedValue]) => {
            uiFormattedData.push({
              key: nestedKey,
              value: nestedValue,
            });
            keysForState.push(key);
          });
        } else if (Array.isArray(value)) {
          // Handle arrays of objects [{ Closed: 1 }, { ss: 0 }]
          value.forEach((item) => {
            if (item && typeof item === "object") {
              Object.entries(item).forEach(([nestedKey, nestedValue]) => {
                uiFormattedData.push({
                  key: nestedKey,
                  value: nestedValue,
                });
                keysForState.push(key);
              });
            }
          });
        }
      });

      setUiData(uiFormattedData);
      setKeyState(keysForState);
    } else {
      console.error("Camapign is undefined or null ");
    }
  };
  useEffect(() => {
    processData();
  }, [CampaignWorkflow]);

  useEffect(() => {
    if (campign?.results?.[0]?.campaign?.id) {
      const filterDataById = ticketDynamicFields?.filter(
        (name) =>
          name?.campaign_name === campign?.results?.[0]?.campaign?.id &&
          name.field_type === "check-box",
      );
      setDynamicFieldData(filterDataById);
    }
  }, [ticketDynamicFields, campign?.results?.[0]?.campaign?.id]);

  console.log(dynamicFieldData, "dynamicFieldData");

  const truncateDescription = (description, maxLength) => {
    if (description?.length > maxLength) {
      return description?.slice(0, maxLength) + "...";
    }
    return description;
  };
  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTotalPages(Math.ceil(campign?.count / pageSize));
    }, 3000);
  }, [currentPage, campign, pageSize]);

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectAll(event.target.checked);
    if (event.target.checked) {
      setSelectedTickets(campign?.results.map((row) => row.id));
    } else {
      setSelectedTickets([]);
    }
  };
  useEffect(() => {
    // Check if all rows are selected to update the "Select All" checkbox
    if (rows.length > 0 && selectedTickets.length === rows.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedTickets, rows]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number,
  ) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const newPageSize = parseInt(event.target.value);
    setPageSize(newPageSize);
    setCurrentPage(1); // Reset to first page when changing page size
    // Trigger refetch with new page size
    setTimeout(() => {
      refetch();
    }, 100);
  };

  const tenant = localStorage.getItem("circleone-user");
  return (
    <div className="card-body pt-0">
      {/* ── Tabs header ── */}
      <div className="tabs-header-section">
        <div className="tabs-header-content">
          <input
            type="checkbox"
            checked={selectAll}
            onChange={handleSelectAll}
            className="select-all-checkbox"
          />
          <Tabs
            value={uiData.findIndex((item) => item.key === value)}
            onChange={(_, newValue) => {
              setStoreKey(keyState[newValue]);
              setValue(uiData[newValue].key);
              setCurrentPage(1);
            }}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              flex: 1,
              minHeight: "44px",
              backgroundColor: "#ffffff",
              "& .MuiTabs-indicator": {
                backgroundColor: "#6366f1",
                height: "2px",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                minHeight: "44px",
                fontSize: "14px",
                fontWeight: 500,
                color: "#6c757d",
                padding: "10px 20px",
                transition: "all 0.2s ease",
                minWidth: "auto",
                "&:hover": { color: "#495057", backgroundColor: "#f8f9fa" },
                "&.Mui-selected": { color: "#6366f1", fontWeight: 600 },
              },
              "& .MuiTabs-scrollButtons": {
                color: "#6c757d",
                "&.Mui-disabled": { opacity: 0.3 },
              },
            }}
          >
            {uiData.map((info, index) => (
              <Tooltip key={index} title={`${info.key} (${info.value})`} arrow>
                <Tab
                  label={truncateDescription(`${info.key} (${info.value})`, 25)}
                />
              </Tooltip>
            ))}
          </Tabs>
        </div>
      </div>

      {/* Scrollable Content Container */}
      <div
        style={{
          height: "calc(100vh - 400px)", // Adjust based on your layout
          overflow: "auto",
          overflowX: "hidden",
          padding: "5px",
        }}
      >
        <TableContainer
          component={Paper}
          style={{ cursor: "pointer", width: "101.5%" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectAll}
                    onChange={handleSelectAll}
                    inputProps={{ "aria-label": "select all" }}
                  />
                </TableCell>

                <TableCell
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Account name
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  First name
                </TableCell>
                <TableCell
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Last name
                </TableCell>

                <TableCell
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Email
                </TableCell>

                <TableCell
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Mobile no.
                </TableCell>

                <TableCell
                  style={{
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  Source
                </TableCell>

                {selectedOptions.length > 0
                  ? selectedOptions.map((option: any) => (
                      <TableCell
                        key={option.id}
                        style={{
                          fontWeight: "600",
                          fontSize: "14px",
                        }}
                      >
                        {option.name}
                      </TableCell>
                    ))
                  : null}
                {/* <TableCell
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Action
              </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={10} style={{ textAlign: "center" }}>
                    <LoadingSpinner />
                  </TableCell>
                </TableRow>
              ) : rows?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10}>
                    <EmptyRows value={""} />
                  </TableCell>
                </TableRow>
              ) : (
                rows?.map((row: any) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    onClick={() => navigate(`/campaign/lead/${row.id}`)}
                  >
                    <TableCell
                      padding="checkbox"
                      onClick={(event) => event.stopPropagation()}
                    >
                      <Checkbox
                        checked={selectedTickets.includes(row.id)}
                        onChange={(event) => handleSelect(event, row.id)}
                        inputProps={{ "aria-label": "select" }}
                      />
                    </TableCell>

                    <TableCell>
                      {capitalizeFirstLetter(row?.account_name)}
                    </TableCell>
                    <TableCell>
                      {capitalizeFirstLetter(row?.first_name)}
                    </TableCell>
                    <TableCell>
                      {capitalizeFirstLetter(row?.last_name)}
                    </TableCell>
                    {/* <TableCell>
                    {capitalizeFirstLetter(row.account_name)}
                  </TableCell> */}
                    <TableCell>
                      {checkUserRole === "agent" && tenant == "briezi"
                        ? maskEmail(row?.email)
                        : capitalizeFirstLetter(row?.email)}
                    </TableCell>
                    {/* <TableCell style={{color: row?.is_high_priority ? "red" : "green"}}>{capitalizeFirstLetter(row?.is_high_priority ? "High" : "Low")}</TableCell> */}

                    <TableCell>
                      {checkUserRole === "agent" && tenant == "briezi"
                        ? maskPhoneNumber(row?.phone_number)
                        : row?.phone_number}
                    </TableCell>

                    {/* Add the check on this */}

                    <TableCell>
                      {capitalizeFirstLetter(row?.channel_name)}
                    </TableCell>

                    {selectedOptions.map((option) => {
                      // Dynamically render table cells based on selected headers
                      const key = option.name;
                      console.log(key);
                      return (
                        <TableCell key={key}>
                          {key === "Lead Id" && row?.id}
                          {/* {key === "Outstanding Amount" && (row?.outstanding_amount ?? 0)} */}
                          {key === "Assignee" &&
                            (row?.assignee ?? "Unassigned")}
                          {key === "Priority" && (
                            <span
                              className={
                                row?.is_high_priority
                                  ? "text-danger"
                                  : "text-success"
                              }
                              style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                                fontSize: "13px",
                              }}
                            >
                              <i
                                className={`bi bi-flag-fill me-1 ${
                                  row?.is_high_priority
                                    ? "text-danger"
                                    : "text-success"
                                }`}
                              ></i>
                              {String(row?.is_high_priority ? "High" : "Low") ??
                                "Unassigned"}
                            </span>
                          )}{" "}
                          {/* Default case for dynamic fields */}
                          {![
                            "Lead Id",
                            "Outstanding Amount",
                            "Assignee",
                            "Priority",
                          ].includes(key) &&
                            (() => {
                              // Find if this key is a check-box field
                              const dynamicField = dynamicFieldData.find(
                                (field) =>
                                  field.label === key &&
                                  field.field_type === "check-box",
                              );
                              let displayValue = row?.dynamic_fields[key];

                              if (dynamicField && Array.isArray(displayValue)) {
                                // Map IDs to choices
                                const choicesMap = Object.fromEntries(
                                  (dynamicField.multiple_choices || []).map(
                                    (c) => [c.id, c.choice],
                                  ),
                                );
                                return displayValue
                                  .map((id) => choicesMap[id] || id)
                                  .join(", ");
                              }
                              // Default rendering for non-checkbox
                              return displayValue !== undefined &&
                                displayValue !== null &&
                                displayValue !== ""
                                ? displayValue
                                : "-";
                            })()}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Fixed Pagination Footer */}
      <div
        style={{
          position: "sticky",
          bottom: 0,
          zIndex: 10,
        }}
      >
        {!loading && (
          <div
            className="d-flex justify-content-between align-items-center mt-4 px-2"
            style={{ marginBottom: "8px" }}
          >
            {/* Left: Rows per page */}
            <div className="d-flex align-items-center gap-4">
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                  Show
                </span>
                <select
                  className="form-select form-select-sm"
                  style={{
                    width: "60px",
                    fontSize: "14px",
                    padding: "2px 6px",
                  }}
                  name="perpage"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                >
                  {pageSizeOptions.map((size) => (
                    <option key={size} value={size}>
                      {size}
                    </option>
                  ))}
                </select>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "#495057",
                  }}
                >
                  per page
                </span>
              </div>
            </div>

            {/* Right: Pagination */}
            <div
              className="d-flex align-items-center"
              style={{ paddingRight: "8px" }}
            >
              <Pagination
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  "& .MuiPaginationItem-root": {
                    fontSize: "14px",
                    minWidth: "36px",
                    height: "36px",
                    margin: "0 2px",
                    borderRadius: "6px",
                    border: "1px solid #e5e7eb",
                    color: "#374151",
                    "&:hover": {
                      backgroundColor: "#f9fafb",
                      borderColor: "#d1d5db",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#6366f1",
                      color: "#ffffff",
                      borderColor: "#6366f1",
                      "&:hover": {
                        backgroundColor: "#4f46e5",
                        borderColor: "#4f46e5",
                      },
                    },
                  },
                }}
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                showFirstButton
                showLastButton
                renderItem={(item) => {
                  if (item.type === "page") {
                    const isNearCurrent =
                      Math.abs(item.page - currentPage) <= 1 ||
                      item.page === 1 ||
                      item.page === totalPages;
                    return isNearCurrent ? <PaginationItem {...item} /> : null;
                  }
                  return <PaginationItem {...item} />;
                }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CampaignListView;
